import React from "react";
import _ from "lodash";

import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

import SoftAvatar from "../../components/SoftAvatar";
import SoftBox from "../../components/SoftBox";
import SoftTypography from "../../components/SoftTypography";
import { useSoftUIController } from "../../context";
import { useLogout } from "../../pages/sign-in/useAuth";
import { getMe } from "../../utils/cache";

/** Displays the signed-in account with a direct logout action and space for long names. */
function SidenavProfile() {
  const [controller] = useSoftUIController();
  const { miniSidenav } = controller;
  const { logout } = useLogout();
  const user = getMe();
  const nameParts = [user?.name, user?.surname].map((name) => name?.trim()).filter(Boolean);
  const fullName = nameParts.join(" ") || user?.email || "Account";
  const initials =
    nameParts
      .map((name) => name.charAt(0))
      .join("")
      .toUpperCase() || fullName.charAt(0).toUpperCase();
  const roleLabel =
    _.map(user?.roles, (role) => _.startCase(_.toLower(role.name))).join(", ") || "Merchant portal";

  return (
    <SoftBox component="footer" mt="auto" px={2} pt={3.75} sx={{ flexShrink: 0 }}>
      <SoftBox pt={1.625} sx={({ palette }) => ({ borderTop: "1px solid " + palette.grey[300] })}>
        <SoftBox
          sx={({ palette }) => ({
            display: "flex",
            alignItems: "center",
            flexDirection: { xs: "row", xl: miniSidenav ? "column" : "row" },
            justifyContent: { xs: "flex-start", xl: miniSidenav ? "center" : "flex-start" },
            width: "100%",
            minHeight: 40,
            padding: "0 5px",
            gap: "10px",
            textAlign: "left",
            color: palette.dark.main,
          })}
        >
          <SoftAvatar
            size="sm"
            aria-hidden="true"
            sx={{
              width: 33,
              height: 33,
              flexShrink: 0,
              border: "1px solid #d4d6c6",
              backgroundColor: "#e8ecdc",
              color: "#0b0b0c",
              fontSize: "11px",
              fontWeight: 700,
            }}
          >
            {initials}
          </SoftAvatar>
          <SoftBox
            minWidth={0}
            flex={1}
            display={{ xs: "block", xl: miniSidenav ? "none" : "block" }}
          >
            <SoftTypography
              component="span"
              fontWeight="medium"
              noWrap
              title={fullName}
              sx={({ typography }) => ({ display: "block", fontSize: typography.size.xs })}
            >
              {fullName}
            </SoftTypography>
            <SoftTypography
              component="span"
              color="secondary"
              noWrap
              title={roleLabel}
              sx={{ display: "block", fontSize: "11px", lineHeight: 1.4 }}
            >
              {roleLabel}
            </SoftTypography>
          </SoftBox>
          <IconButton
            aria-label="Logout"
            title="Logout"
            onClick={logout}
            sx={({ palette }) => ({
              width: 32,
              height: 32,
              flexShrink: 0,
              color: palette.text.main,
              "&:hover": { color: palette.dark.main, backgroundColor: palette.light.main },
            })}
          >
            <Icon sx={{ fontSize: "18px" }}>logout</Icon>
          </IconButton>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
}

export default SidenavProfile;
